<template>
  <div class="div_bic">
    <div class="div1">
      <h3 class="h3">请登记信息</h3>
      <div class="input">
        <div class="lf-platform" @click="selectHandler">
          <div>{{platformName}}</div>
          <div class="arrow"></div>
        </div>
        <van-field class="rt" v-model="text" type="digit" placeholder="请输入券码/自提订单核销码" />
      </div>
    </div>
    <div class="foot-btn navbar-fixed">
      <van-button class="btn" type="info" @click="checkouFun">提交</van-button>
    </div>

    <van-popup  v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="pickerList"
        @confirm="onConfirm($event)"
        @cancel="showPicker = false"
      />
    </van-popup>

  </div>
</template>
<script>
import Util from "@/utils/common";
import http from "@/utils/axios";
export default {
  name: '',
  props: {
    
  },
  data() {
    return {
      text:'',
      pickerList:[
        {
          text:"自有平台",
          value:'1',
        },
        {
          text:"抖音来客",
          value:'2',
        },
      ],
      platformId:'1',
      showPicker:false,
    }
  },
  methods: {
    onConfirm($event){
      console.log("onConfirm---$event---",$event);
      if($event){
        this.platformId = $event.value
      }
      this.showPicker = false
    },
    selectHandler(){
      this.showPicker = true
    },
    thirdPlatformSubmit(){
        console.log("thirdPlatformSubmit----platformId--text-",this.platformId,this.text);
        Util.nativeMethod({tm:3070101,tp:{code:this.text}})
    },
    checkouFun(){
      if(!this.text.replace(/\s+/g, "")){
        this.$toast('请输入券码/自提订单核销码')
        return
      }
      if(this.platformId == 2){
        //第三方平台:跳转原生app核销
        this.thirdPlatformSubmit()
      }else{
        this.onSubmit()
      }
    },
    onSubmit(){
      if (this.text.length == 10) {
        this.querySubOrderIdByTranCode()
        
      } else {
        this.$router.push({name: 'beeHxCodeInfo', query:{code: this.text}})
      }
    },
    querySubOrderIdByTranCode(){
      http({
        url: `order/app/neworder/bees/querySubOrderIdByTranCode/${this.text}`,
        method: "get"
      }).then(res => {
        if (res.code == 200&&res.data) {
          this.$router.push({name: 'orderTranCodePage', query:{subOrderId: res.data}})
        }
      })
    }
  },
  created() {
    this.$loading.hide()
  },
  watch:{},
  destroyed(){},
  mounted(){},
  computed:{
    platformName() {
      let nameStr ="";
      switch(this.platformId){
        case "2":
          nameStr ="抖音来客"; 
          break;
        default:
          nameStr ="自有平台"; 
      }
      return nameStr;
    },
  },
  components: {},
};
</script>
<style lang="less" scoped>
.div_bic{
  height: 100%;
  background: #F7F7F7;
  padding-left: 60px;
  padding-right: 60px;
  box-sizing: border-box;
  overflow: hidden;
  .div1{
    margin-top: 40px;
    font-size: 32px;
    .h3{
      color: #333333;
      line-height: 45px;
      margin-bottom: 34px;
      font-size: 32px;
    }
    .input{
      height: 90px;
      display: flex;
      .lf-platform{
        background: #FFFFFF;
        margin-right: 20px;
        display: flex;
        align-items: center;
        padding: 0 20px ;
        font-size: 28px;
        font-weight: 400;
        color: #333333;
        .arrow{
          width: 40px;
          height: 40px;
          background: url("../../../assets/image/arrow-down-icon.png") no-repeat;
          background-size: 100%;
          display: inline-block;
          margin-left: 10px;
        }
      }
      .rt{
        flex: 1;
        background: #FFFFFF;
      }
    }
  }
  
  .foot-btn {
    background-color: #fff;
    height: 98px;
    text-align: center;
    padding-top: 16px;
    padding-bottom: 6px;
    display: flex;
    align-items: center;
    .btn{
      width: 600px;
      height: 88px;
      background: var(--epButtonColor);
      color: var(--epTextColor);
      border-radius: 44px;
      line-height: 88px;
      font-size: 26px;
      border:0px;
    }
  }
  .navbar-fixed {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    background: #fff;
    display: flex;
    justify-content: center;
    z-index: 3;
    border-top: 0.01rem solid #fafafa;
  }
}
</style>